import React from "react";
import SearchTable from './SearchTable'

export default class SearchTableProductCategory extends SearchTable {
    params = {
        sort_field: 'name',
        sort_order: 'asc',
        page: 1
    };
    formId = 'product-category-search-form';
    varPrefix = 'searchTableProductCategory';
    loadParamsRegExp = [
        /\/cashpoint\/client\/(.*)/g
    ];

    apiUrl = '/api/product-categories';
    sortDef = [
        { key: 'name', name: 'Name' },
        { key: 'created', name: 'Erstellungszeitpunkt' },
        { key: 'modified', name: 'Änderungszeitpunkt' }
    ];

    colDef = [
        { sortField: 'name', text: 'Name' },
        { text: 'Betreiber' },
        { text: 'Aktionen' }
    ];
    
    renderTableRow(row) {
        return (
            <tr key={`product-category-${row.id}`}>
                {this.renderTableCellName(row)}
                {this.renderTableCellOperator(row)}
                {this.renderTableCellActions(row)}
            </tr>
        )
    }

    renderTableCellName(row) {
        return(
            <td>
                {row.name}
            </td>
        )
    }

    renderTableCellLocation(row) {
        return (
            <td>
                {row.name}
            </td>
        )
    }

    renderTableCellActions(row) {
        return(
            <td>
                {this.renderTableCellActionIcon(`/product/category/${row.id}/show`, 'info', 'anzeigen', true)}
                {this.renderTableCellActionIcon(`/product/category/${row.id}/edit`, 'edit', 'bearbeiten', this.capabilities.includes('edit'))}
                {this.renderTableCellActionIcon(`/product/category/${row.id}/delete`, 'trash', 'löschen', this.capabilities.includes('delete'))}
            </td>
        )
    }
}
